// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"416":"1507d6c0","480":"da067ed9","648":"db4cacb1","804":"e67e87f6"}[chunkId] + ".chunk.js";
};